module.exports = __webpack_public_path__ + "img/RHOC.c98d9530.svg";